import { useAssistantStore } from '../stores/assistantStore.js';
import { pick, omit } from 'lodash-es';
import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import { useRouter } from '@fabric-app/compat';

const useAssistantParamIntent = () => {
  const router = useRouter();
  const { assistant } = router.query;
  const { setChatAssistantOpen } = useAssistantStore((s) => pick(s, [
    "setChatAssistantOpen"
  ]));
  useClientLayoutEffect(() => {
    if (!assistant || !router.isReady) return;
    const params = omit(router.query, [
      "assistant"
    ]);
    router.replace({
      query: params
    }, void 0, {
      shallow: true
    });
    if (assistant === "true") setChatAssistantOpen(true);
  }, [
    assistant,
    router.isReady
  ]);
};

export { useAssistantParamIntent };
//# sourceMappingURL=useAssistantParamIntent.js.map
